// src/pages/AboutUs/AboutUs.js
import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  const specialPrograms = [
    'English Readiness Programme',
    'Artsy',
    'Personality Development',
    'Showstopper',
    'Mental Might',
    'Eco-conscious',
    'Tell-a-Tale',
    'Library',
    'Sciencify',
    'Whirl & Twirl',
    'Sensorium',
    'Critical Thinking - Problem solving',
    'Integrated Sanskar',
    'Augmented Reality - Fantasy Box'
  ];

  return (
    <div className="about-page page-content">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <h1 className="page-title">About Us</h1>
          <p className="page-subtitle">Nurturing Unique Potential in Every Child</p>
        </div>
      </section>

      {/* Legacy Section */}
      <section className="legacy-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Our Legacy</h2>
            <div className="title-underline"></div>
          </div>
          <div className="legacy-content">
            <div className="legacy-text">
              <p>
                We believe that there is 'unique potential' in every child; and DisneyLand nurtures it. 
                We nurture and shape minds with the help of our best-in-class age appropriate progressive curriculum. 
              </p>
              <p>
                We are changing the face of early childhood education with consistent upgradation and innovation to 
                meet the current needs with a proactive future, focussed on grooming them to be 'ever-ready for life'. 
              </p>
              <p>
                Our commitment towards quality education also values aspects like self-reliance, peer interaction, 
                and individual growth.
              </p>
            </div>
            <div className="legacy-image">
              <div className="legacy-placeholder">
                <span className="placeholder-icon">🌟</span>
                <p>Excellence in Early Education</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* DisneyLand Advantages */}
      <section className="advantages-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">DisneyLand Advantages</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">
              We encourage, educate, and equip today's children to be tomorrow's leaders.
            </p>
          </div>
          <div className="advantages-list">
            <div className="advantage-item">
              <div className="advantage-icon">✓</div>
              <div className="advantage-content">
                <h3>Focus on What is Right for the Child</h3>
                <p>Every child is unique, and we tailor our approach to meet individual needs and learning styles.</p>
              </div>
            </div>
            <div className="advantage-item">
              <div className="advantage-icon">✓</div>
              <div className="advantage-content">
                <h3>Safety and Security is a Priority</h3>
                <p>Your child's safety is our top concern with secure premises and trained staff.</p>
              </div>
            </div>
            <div className="advantage-item">
              <div className="advantage-icon">✓</div>
              <div className="advantage-content">
                <h3>Integrated Pentemind Curriculum</h3>
                <p>Our curriculum develops five essential minds: Empathetic, Conscientious, Focused, Analytical, and Inventive.</p>
              </div>
            </div>
            <div className="advantage-item">
              <div className="advantage-icon">✓</div>
              <div className="advantage-content">
                <h3>I Care and Trained Facilitators</h3>
                <p>Our caring and professionally trained teachers create a nurturing learning environment.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Mission */}
      <section className="vision-mission-section">
        <div className="container">
          <div className="vm-grid">
            <div className="vm-card vision-card">
              <div className="vm-icon">🎯</div>
              <h2>Our Vision</h2>
              <div className="vm-divider"></div>
              <p>
                We are committed to instilling skills, knowledge, and values in our children in order to give them 
                an inner voice to face the challenges of the twenty-first century.
              </p>
              <p>
                Our learning environment allows each child to nurture the learning minds namely the Empathetic Mind, 
                Conscientious Mind, Focused Mind, Analytical Mind, and Inventive Mind.
              </p>
            </div>
            <div className="vm-card mission-card">
              <div className="vm-icon">🌟</div>
              <h2>Our Mission</h2>
              <div className="vm-divider"></div>
              <p>
                To provide a safe, nurturing, and stimulating environment where children can explore, discover, and 
                develop to their fullest potential.
              </p>
              <p>
                We aim to foster a love for learning through play-based activities, innovative teaching methods, and 
                a curriculum that promotes holistic development.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* DisneyLand Special Programs */}
      <section className="special-programs-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">DisneyLand Special Programs</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">
              Unique programs designed to make learning fun and engaging
            </p>
          </div>
          <div className="programs-showcase">
            {specialPrograms.map((program, index) => (
              <div key={index} className="program-badge">
                <span className="badge-icon">⭐</span>
                <span className="badge-text">{program}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Why Choose DisneyLand?</h2>
            <div className="title-underline"></div>
          </div>
          <div className="choose-grid">
            <div className="choose-card">
              <div className="choose-number">01</div>
              <h3>Best-in-Class Curriculum</h3>
              <p>Age-appropriate progressive curriculum designed by experts</p>
            </div>
            <div className="choose-card">
              <div className="choose-number">02</div>
              <h3>Trained Facilitators</h3>
              <p>Professionally trained and caring teachers who love what they do</p>
            </div>
            <div className="choose-card">
              <div className="choose-number">03</div>
              <h3>Safe Environment</h3>
              <p>Secure premises with CCTV monitoring and strict safety protocols</p>
            </div>
            <div className="choose-card">
              <div className="choose-number">04</div>
              <h3>Holistic Development</h3>
              <p>Focus on cognitive, physical, social, and emotional growth</p>
            </div>
            <div className="choose-card">
              <div className="choose-number">05</div>
              <h3>Individual Attention</h3>
              <p>Small class sizes ensuring personalized care for each child</p>
            </div>
            <div className="choose-card">
              <div className="choose-number">06</div>
              <h3>Parent Partnership</h3>
              <p>Regular communication and involvement of parents in learning journey</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;